import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import Error404 from "modules/core/pages/Error404";

import { experimentsPrivateRoutesConstants as routesConstants } from "./routesConstants";

import { componentLazyImport } from "modules/core/utils/helpers";

// Pages
const ExperimentsKanban = lazy(() =>
  componentLazyImport(
    () => import("modules/experiments/pages/ExperimentsKanban")
  )
);

const SingleExperiment = lazy(() =>
  componentLazyImport(
    () => import("modules/experiments/pages/SingleExperiment")
  )
);

const CreateExperiment = lazy(() =>
  componentLazyImport(
    () => import("modules/experiments/pages/CreateExperiment")
  )
);

const EditExperiment = lazy(() =>
  componentLazyImport(() => import("modules/experiments/pages/EditExperiment"))
);

const ExperimentsPrivateRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path={routesConstants.root.path} exact>
        <ExperimentsKanban />
      </Route>

      <Route path={routesConstants.create_experiment.path} exact>
        <CreateExperiment />
      </Route>

      <Route path={routesConstants.edit_experiment.path} exact>
        <EditExperiment />
      </Route>

      <Route path={routesConstants.single_experiment.path} exact>
        <SingleExperiment />
      </Route>

      <Route>
        <Error404 />
      </Route>
    </Switch>
  );
};

export default ExperimentsPrivateRoutes;
